import { render, staticRenderFns } from "./modalAsignarContrasena.vue?vue&type=template&id=b78a8d04&scoped=true&"
import script from "./modalAsignarContrasena.vue?vue&type=script&lang=js&"
export * from "./modalAsignarContrasena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78a8d04",
  null
  
)

export default component.exports